export default __webpack_public_path__ + "static/media/work-process-3.892549a6.jpg";